import React, { useEffect, useState } from "react";
import { UrlApiEnvasado } from "../../../services/apirest";
import { useLocation, useNavigate } from "react-router-dom"; // Importar useNavigate
import {
  CircularProgress,
  Card,
  CardContent,
  Typography,
  Grid,
  TextField,
  Button,
  IconButton,
  Collapse,
  AppBar,
  Toolbar,
} from "@mui/material";
import { styled } from "@mui/system";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ArrowBackIcon from "@mui/icons-material/ArrowBack"; // Icono de retroceso
import moment from "moment";
import ListadoClientesChofer from "./ListadoClientesChofer";
import VistaFacturasChofer from "./VistaFacturasChofer";

// Estilos personalizados
const StyledCard = styled(Card)(({ theme }) => ({
  borderRadius: "12px",
  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
  transition: "transform 0.3s ease-in-out",
  "&:hover": {
    transform: "scale(1.05)",
  },
}));

const StyledButton = styled(Button)(({ theme }) => ({
  backgroundColor: "#2471A3",
  color: "#ffffff",
  "&:hover": {
    backgroundColor: "#8A9597",
  },
}));

const StyledButtonFac = styled(Button)(({ theme }) => ({
  backgroundColor: "#5c3dcf",
  color: "#ffffff",
  "&:hover": {
    backgroundColor: "#8A9597",
  },
}));

const GradientBackground = styled("div")(({ theme }) => ({
  background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
  minHeight: "calc(100vh - 64px)", // Restar la altura del AppBar
  padding: "20px",
  overflowY: "auto", // Scroll solo si es necesario
}));
function DatosChoferes() {
  const location = useLocation();
  const navigate = useNavigate(); // Hook para navegar
  const [cantidadVentas, setCantidadVentas] = useState(null);
  const [cantidadEnvases, setCantidadEnvases] = useState(null);
  const [precios, setPrecios] = useState(null);
  const [loading, setLoading] = useState(false);
  const hoy = moment().format("YYYY-MM-DD");
  const unMesAntes = moment().subtract(1, "months").format("YYYY-MM-DD");

  const [fechaDesde, setFechaDesde] = useState(unMesAntes);
  const [fechaHasta, setFechaHasta] = useState(hoy);
  const [listado, setListado] = useState(false);
  const [facturas, setFacturas] = useState(false)
  const [expanded, setExpanded] = useState({
    ventas: false,
    envases: false,
    precios: false,
  });

  const fetchData = () => {
    setLoading(true);
    Promise.all([
      fetch(
        `${UrlApiEnvasado}api/estadistica/xchofer/cantidadventas/${fechaDesde}/${fechaHasta}/${location.state.id_user}`
      ).then((res) => res.json()),
      fetch(
        `${UrlApiEnvasado}api/estadistica/xchofer/cantidadenvases/${fechaDesde}/${fechaHasta}/${location.state.id_user}`
      ).then((res) => res.json()),
      fetch(
        `${UrlApiEnvasado}api/estadistica/xchofer/precios/${fechaDesde}/${fechaHasta}/${location.state.id_user}`
      ).then((res) => res.json()),
    ])
      .then(([ventasData, envasesData, preciosData]) => {
        setCantidadVentas(ventasData);
        setCantidadEnvases(envasesData);
        setPrecios(preciosData);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchData();
  }, []);

  console.log(location.state);
  

  const handleExpandClick = (card) => {
    setExpanded((prev) => ({
      ...prev,
      [card]: !prev[card],
    }));
  };

  const handleDetailClick = (card) => {
    setListado(true);
  };

  const handleVerFacturas = (card) => {
    setFacturas(true);
  };

  const handleGoBack = () => {
    navigate(-1); // Navegar a la página anterior
  };

  return (
    <>
      {/* AppBar con el título y botón de retroceso */}
      <AppBar position="static" style={{ backgroundColor: "#2471A3" }}>
        <Toolbar>
          {/* Botón de retroceso */}
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleGoBack}
            style={{ marginRight: "16px" }}
          >
            <ArrowBackIcon />
          </IconButton>
          {/* Título centrado */}
          <Typography
            variant="h6"
            style={{
              flexGrow: 1,
              textAlign: "center",
              fontWeight: "600",
              letterSpacing: "1px",
            }}
          >
            Estadísticas de {location.state.name}
          </Typography>
          {/* Espacio para equilibrar el botón de retroceso */}
          <div style={{ width: "48px" }}></div>
        </Toolbar>
      </AppBar>

      {/* Contenido principal */}
      <GradientBackground>
        {/* Filtros por fecha */}
        <Grid
          container
          spacing={2}
          justifyContent="center"
          alignItems="center"
          style={{ marginBottom: "20px" }}
        >
          <Grid item>
            <TextField
              size="small"
              label="Desde"
              type="date"
              value={fechaDesde}
              onChange={(e) => setFechaDesde(e.target.value)}
              InputLabelProps={{ shrink: true }}
              variant="outlined"
            />
          </Grid>
          <Grid item>
            <TextField
              size="small"
              label="Hasta"
              type="date"
              value={fechaHasta}
              onChange={(e) => setFechaHasta(e.target.value)}
              InputLabelProps={{ shrink: true }}
              variant="outlined"
            />
          </Grid>
          <Grid item>
            <StyledButton variant="contained" onClick={fetchData}>
              Actualizar
            </StyledButton>
          </Grid>
          <Grid item>
            <StyledButtonFac variant="contained" onClick={handleVerFacturas}>
              Ver Facturas
            </StyledButtonFac>
          </Grid>
        </Grid>

        {loading ? (
          <Grid container justifyContent="center">
            <CircularProgress style={{ color: "#6200ea" }} />
          </Grid>
        ) : (
          <Grid container spacing={3}>
            {/* Cantidad de ventas */}
            <Grid item xs={12} md={4}>
              <StyledCard
                style={{
                  backgroundColor: "#ffffff",
                  border: "1px solid #e0e0e0",
                }}
              >
                <CardContent>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      variant="h6"
                      style={{ color: "#2c3e50", fontWeight: "600" }}
                    >
                      Cantidad de Ventas
                    </Typography>
                    <div>
                      <IconButton onClick={() => handleDetailClick("ventas")}>
                        <VisibilityIcon style={{ color: "#2471A3" }} />
                      </IconButton>
                      <IconButton onClick={() => handleExpandClick("ventas")}>
                        <ExpandMoreIcon
                          style={{
                            transform: expanded.ventas
                              ? "rotate(180deg)"
                              : "rotate(0deg)",
                          }}
                        />
                      </IconButton>
                    </div>
                  </div>
                  <Collapse in={expanded.ventas} timeout="auto" unmountOnExit>
                    <Typography style={{ color: "#555", marginTop: "10px" }}>
                      Clientes distintos:{" "}
                      {cantidadVentas?.[0]?.clientes_distintos_adi || 0}
                    </Typography>
                    {/* <Typography style={{ color: '#555' }}>
                                            Clientes adicionales: {cantidadVentas?.[0]?.clientes_distintos_adi || 0}
                                        </Typography> */}
                  </Collapse>
                </CardContent>
              </StyledCard>
            </Grid>

            {/* Cantidad de envases vendidos */}
            <Grid item xs={12} md={4}>
              <StyledCard
                style={{
                  backgroundColor: "#ffffff",
                  border: "1px solid #e0e0e0",
                }}
              >
                <CardContent>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      variant="h6"
                      style={{ color: "#2c3e50", fontWeight: "600" }}
                    >
                      Cantidad de Envases Vendidos
                    </Typography>
                    <div>
                      {/* <IconButton onClick={() => handleDetailClick('envases')}>
                                                <VisibilityIcon style={{ color: '#2471A3' }} />
                                            </IconButton> */}
                      <IconButton onClick={() => handleExpandClick("envases")}>
                        <ExpandMoreIcon
                          style={{
                            transform: expanded.envases
                              ? "rotate(180deg)"
                              : "rotate(0deg)",
                          }}
                        />
                      </IconButton>
                    </div>
                  </div>
                  <Collapse in={expanded.envases} timeout="auto" unmountOnExit>
                    {cantidadEnvases && cantidadEnvases[0] ? (
                      cantidadEnvases.map((envase, index) => (
                        <div
                          key={index}
                          style={{ marginTop: index === 0 ? "10px" : "15px" }}
                        >
                          <Typography
                            variant="subtitle1"
                            style={{ color: "#2c3e50", fontWeight: "500" }}
                          >
                            {envase.tipo_envase}
                          </Typography>
                          <Typography style={{ color: "#555" }}>
                            Unidades: {envase.cantidad_vendida}
                          </Typography>
                          <Typography style={{ color: "#555" }}>
                            Peso total: {envase.peso_total_vendido} kg
                          </Typography>
                        </div>
                      ))
                    ) : (
                      <Typography style={{ color: "#555" }}>
                        No hay Datos
                      </Typography>
                    )}
                  </Collapse>
                </CardContent>
              </StyledCard>
            </Grid>

            {/* Precios */}
            <Grid item xs={12} md={4}>
              <StyledCard
                style={{
                  backgroundColor: "#ffffff",
                  border: "1px solid #e0e0e0",
                }}
              >
                <CardContent>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      variant="h6"
                      style={{ color: "#2c3e50", fontWeight: "600" }}
                    >
                      Precios
                    </Typography>
                    <div>
                      {/* <IconButton onClick={() => handleDetailClick("precios")}>
                        <VisibilityIcon style={{ color: "#2471A3" }} />
                      </IconButton> */}
                      <IconButton onClick={() => handleExpandClick("precios")}>
                        <ExpandMoreIcon
                          style={{
                            transform: expanded.precios
                              ? "rotate(180deg)"
                              : "rotate(0deg)",
                          }}
                        />
                      </IconButton>
                    </div>
                  </div>
                  <Collapse in={expanded.precios} timeout="auto" unmountOnExit>
                    {precios && precios[0] ? (
                      precios.map((producto, index) => (
                        <div
                          key={index}
                          style={{ marginTop: index === 0 ? "10px" : "15px" }}
                        >
                          <Typography
                            variant="subtitle1"
                            style={{ color: "#2c3e50", fontWeight: "500" }}
                          >
                            {producto.tipo_producto}
                          </Typography>
                          <Typography style={{ color: "#555" }}>
                            Mínimo: ${producto.precio_minimo}
                          </Typography>
                          <Typography style={{ color: "#555" }}>
                            Máximo: ${producto.precio_maximo}
                          </Typography>
                          <Typography style={{ color: "#555" }}>
                            Promedio: ${producto.precio_promedio.toFixed(2)}
                          </Typography>
                        </div>
                      ))
                    ) : (
                      <Typography style={{ color: "#555" }}>
                        No hay Datos
                      </Typography>
                    )}
                  </Collapse>
                </CardContent>
              </StyledCard>
            </Grid>
          </Grid>
        )}
      </GradientBackground>
      {listado && (
        <ListadoClientesChofer
          open={listado}
          setOpen={setListado}
          fechaDesde={fechaDesde}
          fechaHasta={fechaHasta}
          chofer={location.state.id_user}
        />
      )}
      {facturas && (
        <VistaFacturasChofer
          open={facturas}
          setOpen={setFacturas}
          fechaDesde={fechaDesde}
          fechaHasta={fechaHasta}
          chofer={location.state.id_user}
          nombre={location.state.name}
        />
      )}
    </>
  );
}

export default DatosChoferes;
